import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';

import classes from './QuillEditor.module.scss';
import './QuillEditor.css';

const QuillEditor = props => {
    const [touched, setTouched] = useState(false);
    const [focus, setFocus] = useState(false);
    const [isValid, setIsValid] = useState(false);

    const inputClasses = [classes.Editor];
    const inputClassesFocus = [classes.EditorFocus];
    let errorMessage = null;

    useEffect(() => {
        if (props.state.length >= props.config.minLength) {
            setIsValid(true);
        }
        if (props.state.length < props.config.minLength) {
            setIsValid(false);
        }
    }, [props.state, props.config.minLength])

    if (props.config.required && touched && !isValid) {
        inputClasses.push(classes.Invalid);
        inputClassesFocus.push(classes.Invalid);
        errorMessage = <small className={classes.ErrorMessage}>{props.config.errorMessage}</small>;
    }

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'header': [3, false] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            // ['link', 'image'],
            // ['clean']
        ]
    }

    const formats = [
        'bold', 'italic', 'underline',
        'header',
        'list', 'bullet', 'indent',
        'link', 'image'
    ]


    const onFocusHandler = () => {
        setFocus(true);
        setTouched(true);
    }

    const onBlurHandler = () => {
        setFocus(false);
    }

    return <div className={classes.QuillEditor}>
        <div className={classes.Label}>
            {props.label}
        </div>
        {errorMessage}
        <div className={focus ? inputClassesFocus.join(' ') : inputClasses.join(' ')} onFocus={onFocusHandler} onBlur={onBlurHandler}>
            <ReactQuill
                className={classes.QuillComponent}
                theme="snow"
                value={props.state}
                onChange={props.onStateChange}
                modules={modules}
                formats={formats} />
        </div>

    </div >
}

export default QuillEditor;